export function ccyFormat(num: number) {
  return `${num.toFixed(2)}`;
}
